import api from './api';

const expenseService = {
  getAll: async (params = {}) => {
    const response = await api.get('/expenses', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/expenses/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/expenses', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/expenses/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/expenses/${id}`);
    return response.data;
  },

  getCategories: async () => {
    const response = await api.get('/expenses/categories');
    return response.data;
  },

  createCategory: async (name) => {
    const response = await api.post('/expenses/categories', { name });
    return response.data;
  },

  getSummary: async (params = {}) => {
    const response = await api.get('/expenses/summary', { params });
    return response.data;
  },

  getProfit: async (params = {}) => {
    const response = await api.get('/expenses/profit', { params });
    return response.data;
  },
};

export default expenseService;
